<template>
    <div class="page home-page py-lg-4">
        <transition name="fade-transition">
            <v-container v-if="!loading && homeData.latest_courses !== null" :class="{'pa-0': phoneOnly}">

                <!-- Header Slider -->
                <div v-if="headerImages && headerImages.length" class="mb-2 mb-lg-6" :class="{'mx-5 mt-5': phoneOnly}">
                    <v-carousel :show-arrows-on-hover="headerImages.length > 1" cycle :height="pcOnly ? 450 : 165" :show-arrows="headerImages.length > 1 && pcOnly" :continuous="true" class="header-carousel" :hide-delimiters="headerImages.length <= 1" :class="{'bordered': (!headerImages || !headerImages.length)}">
                        <template v-slot:prev="{ on, attrs }">
                            <v-btn large fab v-bind="attrs" v-on="on" class="transparent" depressed>
                                <v-icon large>mdi-chevron-right</v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:next="{ on, attrs }">
                            <v-btn large fab v-bind="attrs" v-on="on" class="transparent" depressed>
                                <v-icon large>mdi-chevron-left</v-icon>
                            </v-btn>
                        </template>
                        <v-carousel-item v-for="(img,i) in headerImages" :key="i" @click="imageClickAction(img)" v-ripple="!!img.href && phoneOnly" :class="{'e-link': !!img.href || !!img.to}">
                            <div :style="`width: 100%; height: 100%; background-image: url(${img.url}); background-size: cover; background-position: center;`" />
                            <!-- <v-img :src="img.url" center contain></v-img> -->
                        </v-carousel-item>
                    </v-carousel>
                </div>

                <v-card v-if="phoneOnly" flat class="mb-lg-6">
                    <div class="py-2 w-100 px-2">
                        <div v-if="pcOnly" class="px-4">
                            <div style="font-size: 1.3rem" class="strong-text--text mb-1">
                                أهلا بك<span class="mx-1">{{user.name}}</span> مجدداً
                            </div>
                            <p class="medium-text">ابدأ اﻵن بتصفح دوراتك والحصص الجديدة!</p>
                        </div>
                        <v-list v-if="homeMode === 'classic'" :max-width="pcOnly ? 500 : undefined" min-width="300">
                            <v-list-item :dark="phoneOnly" :to="{name: 'my-courses'}" :class="{'primary md-shadow md-rounded mb-3 mx-3': phoneOnly}">
                                <v-list-item-icon>
                                    <v-icon>mdi-book-multiple-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>دوراتي</v-list-item-title>
                                <v-list-item-icon>
                                    <v-icon style="opacity: 0.5" size="22">mdi-chevron-left</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                            <v-list-item :dark="phoneOnly" :to="{name: 'courses'}" :class="{'primary md-shadow md-rounded mb-2 mx-3': phoneOnly}">
                                <v-list-item-icon>
                                    <v-icon>mdi-play-box-multiple-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>الدورات التعليمية</v-list-item-title>
                                <v-list-item-icon>
                                    <v-icon style="opacity: 0.5" size="22">mdi-chevron-left</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                        </v-list>
                        <div v-else-if="homeMode === 'default'" class="px-4 my-4">
                            <v-row>
                                <v-col :cols="i === navItems.length-1 && navItems.length%2 !== 0 ? 12 : 6" v-for="(item, i) in navItems" :key="item.name" class="pa-2">
                                    <v-card flat class="px-3 py-3 bordered" style="border-radius: 10px;!important; border-color: rgba(0,0,0, .12)!important;" :to="{name: item.name}" v-ripple="{class: 'ripple--color'}">
                                        <div class="d-flex flex-column align-center">
                                            <v-icon size="26" :color="item.color">{{item.icon}}</v-icon>
                                            <div class="mt-2">
                                                <div class="strong-text--text details-text">{{item.text}}</div>
                                            </div>
                                        </div>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </v-card>
                <!-- <v-divider v-if="phoneOnly"></v-divider> -->
                <v-fade-transition>
                <v-card v-if="featuredCourses && featuredCourses.length" flat class="section-card mb-lg-10">
                    <v-card-title v-if="pcOnly" class="d-flex justify-space-between pt-0 pt-lg-4" :style="pcOnly ? 'font-size: 1.4rem' : ''">
                        <div>الدورات المقترحة</div>
                        <div v-if="pcOnly">
                            <v-btn color="primary" :to="{name: 'courses'}" depressed>
                                <v-icon left>mdi-play-box-multiple-outline</v-icon>
                                كل الدورات
                            </v-btn>
                        </div>
                    </v-card-title>
                    <v-card-subtitle v-if="pcOnly">قائمة الدورات المميزة المقترحة لك</v-card-subtitle>
                    <v-subheader v-if="phoneOnly" class="mt-2">الدورات المقترحة</v-subheader>
                    <v-card-text class="pt-0 py-lg-4 px-0 px-lg-4">
                        <template v-if="!loading">
                            <div v-if="pcOnly">
                                <v-row>
                                    <v-col cols="12" md="6" lg="3" v-for="(course, i) in featuredCoursesComputed" :key="course.id + '-' + i" class="py-2">
                                        <course-card short :course="course"> </course-card>
                                    </v-col>
                                </v-row>
                            </div>
                            <v-list v-else two-line class="pa-0">
                                <course-list-item v-for="(course, i) in featuredCourses" :key="course.id + '-' + i" :course="course" />
                            </v-list>
                        </template>
                    </v-card-text>
                </v-card>
                </v-fade-transition>

                <v-fade-transition>
                <v-card v-if="latestCourses && latestCourses.length" flat class="section-card mb-4">
                    
                    <v-card-title v-if="pcOnly" class="d-flex justify-space-between" :style="pcOnly ? 'font-size: 1.4rem' : ''">
                        <div>الدورات اﻷحدث</div>
                        <div v-if="pcOnly">
                            <v-btn color="primary" :to="{name: 'courses'}" depressed>
                                <v-icon left>mdi-play-box-multiple-outline</v-icon>
                                كل الدورات
                            </v-btn>
                        </div>
                    </v-card-title>
                    <v-card-subtitle v-if="pcOnly">الدورات الجديدة أو التي تحتوي على محاضرات جديدة</v-card-subtitle>
                    <v-subheader v-if="phoneOnly" class="mt-2">الدورات اﻷحدث</v-subheader>

                    <v-card-text class="pt-0 py-lg-4 px-0 px-lg-4">
                        <template v-if="!loading">
                        <div v-if="pcOnly">
                            <v-row>
                                <v-col cols="12" md="6" lg="3" v-for="(course, i) in latestCoursesComputed" :key="`latest-${course.id}-${i}`" class="py-2">
                                    <course-card short :course="course"> </course-card>
                                </v-col>
                            </v-row>
                        </div>
                        <v-list v-else two-line class="pa-0">
                            <course-list-item v-for="(course, i) in latestCourses" :key="`latest-${course.id}-${i}`" :course="course" />
                        </v-list>
                        </template>
                    </v-card-text>
                </v-card>
                </v-fade-transition>
            </v-container>
        </transition>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import CourseCard from '@/components/custom/course-card'
import CourseListItem from '@/components/custom/course-list-item'

export default {
    name: "Home",
    components: {
        CourseCard,
        CourseListItem
    },
    data(){
        return {
            loading: false,

            showMoreFeatured: false,
            showMoreLatest: false,
        }
    },
    computed: {
        homeData(){
            return this.$store.state.globalModule.homeData;
        },
        headerImages(){
            return this.homeData ? this.homeData.header_images : [];
        },
        featuredCourses(){
            return this.homeData ? this.homeData.featured_courses : [];
        },
        featuredCoursesComputed(){
            if (this.featuredCourses){
                return this.showMoreFeatured ? this.featuredCourses : this.featuredCourses.slice(0, 4);
            }
            return [];
        },
        latestCoursesComputed(){
            if (this.latestCourses){
                return this.showMoreLatest ? this.latestCourses : this.latestCourses.slice(0, 4);
            }
            return [];
        },
        latestCourses(){
            return this.homeData ? this.homeData.latest_courses : [];
        },
        homeMode(){
            return this.appData.home_mode || 'default';
        },
        navItems(){
            let items = [
                {name: 'my-courses', text: 'دوراتي', icon: 'mdi-book-multiple-outline', color: 'primary', foreground: 'primary lighten-5'},
                {name: 'courses', text: 'الدورات التعليمية', icon: 'mdi-play-box-multiple-outline', color: 'primary', foreground: 'primary lighten-5'},
                {name: 'profile', text: 'الملف الشخصي', icon: 'mdi-account-circle-outline', color: 'strong-text', foreground: 'green lighten-5'},
                {name: 'teachers', text: 'المحاضرين', icon: 'mdi-account-tie-outline', color: 'strong-text', foreground: 'grey lighten-3', hide: !this.appData.teachers_page},
                {name: 'exams', text: 'الامتحان اﻹلكتروني', icon: 'mdi-clipboard-text-outline', color: 'deep-purple darken-1', foreground: 'deep-purple lighten-5', hide: !this.appData.enable_gen_exm},
                {name: 'my-exams', text: 'نتائج امتحاناتي', icon: 'mdi-license', color: 'deep-purple darken-1', foreground: 'deep-purple lighten-5'},
                {name: 'wallet', text: 'المحفظة الإلكترونية', icon: 'mdi-wallet-outline', color: 'deep-orange darken-1', foreground: 'orange lighten-5', hide: !this.appData.enable_wallet_system},
                // {name: 'help', text: 'المساعدة', icon: 'mdi-help-circle-outline', color: 'strong-text', foreground: 'grey lighten-3'},
            ];
            return items.filter(item=>{return !item.hide});
        },
        ...GlobalComputed
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;

                this.$store.dispatch('loadHomeData').then(()=>{
                    this.loading = false;
                }).catch(()=>{
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
        imageClickAction(img){
            if (img.href){
                window.open(img.href, "_system");
            }else if (img.to){
                this.$router.push(img.to);
            }
        },

        checkAppAutoLogin(){
            if (!this.capRunning && this.phoneAndTablet && this.appData.enable_wallet_system){
                let tk = this.$route.query.tk;
                if (tk && this.$route.query.from === 'app' && this.$route.query.to === 'w'){
                    tk = tk.split('').reverse().join('');
                    // this.$router.push({query: {}});
                    window.localStorage.setItem('tK', tk);
                    // this.$router.push({name: 'wallet'});
                    let redirectTo = '/wallet';
                    if (this.$route.query.q){
                        redirectTo += '?';
                        redirectTo += this.$route.query.q.replaceAll(':', '=').replaceAll('|', '&');
                    }
                    window.location = redirectTo;
                }
            }
        }
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        }
    },
    created(){
        if (this.$route.query.course){
            this.$router.push({name: 'course', params: {id: this.$route.query.course}});
        }
        this.checkAppAutoLogin();
    },
    mounted(){
        if (!this.latestCourses || this.latestCourses.length === 0){
            this.loadData();
        }
    }
    
};
</script>

<style lang="scss" scoped>
    @media (min-width: 756px) {
        .v-card.section-card{
            .v-card__title, .v-card__subtitle, .v-card__text{
                padding-left: 0!important;
                padding-right: 0!important;
            }
        }
    }
    .header-carousel{
        border-radius: 10px;
        border: 1px solid rgba(0,0,0, .1);

        @media(min-width: 960px){
            border-radius: 5px;
        }
    }
</style>
<style lang="scss">
.v-window__prev, .v-window__next{
    background: none!important;
}
.v-carousel__controls{
    background: none!important;
    .v-carousel__controls__item{
        margin: 0 2px!important;

        .v-icon.mdi-circle{
            font-size: 15px!important;
        }
    }
}
.v-carousel__controls .v-carousel__controls__item{
    margin: 0!important;
}
.v-carousel__controls .v-carousel__controls__item .v-icon.mdi-circle{
    font-size: 10px!important;
}
.v-carousel__controls .v-carousel__controls__item.v-btn--active .v-icon.mdi-circle{
    font-size: 14px!important;
}
</style>
